import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router'
import { ListGroup, Button } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import { setAccountDeletionState } from '@severed-links/common.redherrings-reducers/accountDeletion'
import * as s from './AccountDeletionStep.scss'

const InstructionsStep = forwardRef(({ jumpToStep, ...props }, _ref) => {

    const dispatch = useDispatch()
    const params = useParams()
    const navigate = useNavigate()
    const playerId = useSelector(state => state.account._id)
    const _accountDeletion = useSelector(state => state.accountDeletion)
    const { 
        isFetching, playerInfoSelections, playerInfoSelection, firstName, lastName, address, 
        city, state, zip, emailAddress, cellPhone, imageUrl, accountDeletionConfirmed, 
    } = _accountDeletion
    const _isValidated = true

    useEffect(() => {
    }, [])

    useImperativeHandle(_ref, () => ({
        isValidated: () => _isValidated,
    }))


    return (
        <div className={s.container}>
            <h4>We're sorry to see you go!</h4>
            <p>
                This portal will assist you in deleting your REDHERRINGS
                account and any associated personally-identifying information.  
                Deletion is permanent.
            </p>

            <div className={s.cancelContainer}>
                <Button variant='light' onClick={() => navigate(`/${params.appName || 'main'}/user-profile/edit-profile`)}><FontAwesomeIcon name='times' /> cancel and return to my profile</Button>
            </div>


        </div>
    )
})

export default InstructionsStep
